module.exports = __webpack_public_path__ + "img/scb.6b2bb4a1.jpg";